import { render, staticRenderFns } from "./BtnFacebookLogin.vue?vue&type=template&id=3ec73ddf&scoped=true&"
import script from "./BtnFacebookLogin.vue?vue&type=script&lang=js&"
export * from "./BtnFacebookLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec73ddf",
  null
  
)

export default component.exports